import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

// Replace these with your actual EmailJS credentials from https://emailjs.com
const SERVICE_ID  = 'service_voc2qkv';
const TEMPLATE_ID = 'template_nffzgn8';
const PUBLIC_KEY  = '8vDpBIMujnP20w9Qn';

function Contact() {
  const [form, setForm]       = useState({ name: '', email: '', phone: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          from_name:  form.name,
          from_email: form.email,
          phone:      form.phone || 'Not provided',
          message:    form.message,
          to_email:   'nikhilyadav2698@gmail.com',
        },
        PUBLIC_KEY
      );
      setSubmitted(true);
    } catch (err) {
      console.error('EmailJS error:', err);
      setError(`Error: ${err?.text || err?.message || JSON.stringify(err)}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="contact-page">
      <section className="page-header">
        <div className="page-header-inner">
          <span className="section-label">Reach Out</span>
          <h1>Contact Us</h1>
          <p>Have a question or want to discuss your wafer requirements? We'd love to hear from you.</p>
        </div>
      </section>

      <section className="contact-section">
        <div className="contact-inner">

          {/* Info Panel */}
          <div className="contact-info">
            <h2>Get in Touch</h2>
            <p>Whether you're a fab, research lab, or startup — we're here to help you find the right silicon wafer solution.</p>

            <div className="info-items">
              <div className="info-item">
                <span className="info-icon">📧</span>
                <div>
                  <span className="info-label">Email</span>
                  <a href="mailto:darshanpawar18@gmail.com">darshanpawar18@gmail.com</a>
                </div>
              </div>
              <div className="info-item">
                <span className="info-icon">📞</span>
                <div>
                  <span className="info-label">Phone</span>
                  <a href="tel:2692766645">269-276-6645</a>
                </div>
              </div>
              <div className="info-item">
                <span className="info-icon">🏢</span>
                <div>
                  <span className="info-label">Company</span>
                  <span>Seminexis Pvt Ltd</span>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="contact-form-wrap">
            {submitted ? (
              <div className="success-message">
                <span className="success-icon">✅</span>
                <h3>Message Sent!</h3>
                <p>Your email client should have opened. We'll get back to you shortly.</p>
                <button className="btn-primary" onClick={() => setSubmitted(false)}>Send Another</button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit} noValidate>
                <h2>Send a Message</h2>

                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Your full name"
                    required
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      id="email"
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="you@example.com"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone (optional)</label>
                    <input
                      id="phone"
                      type="tel"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      placeholder="+91 XXXXX XXXXX"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Tell us about your requirements..."
                    rows={5}
                    required
                  />
                </div>

                {error && <p className="form-error">{error}</p>}
                <button type="submit" className="btn-primary submit-btn" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Message →'}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </main>
  );
}

export default Contact;
